/**
 * Výčtový typ obsahující všechny dostupné role, které může element mít.
 * Využívá se pro přístupnost komponent a předává se do atributu "role" elementu.
 * @see https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques#Roles
 */
export enum Role {
    button = "button",
    checkBox = "checkbox",
    gridCell = "gridcell",
    link = "link",
    menuItem = "menuitem",
    menuItemCheckBox = "menuitemcheckbox",
    menuItemRadio = "menuitemradio",
    option = "option",
    progressBar = "progressbar",
    radio = "radio",
    scrollBar = "scrollbar",
    searchBox = "searchbox",
    separator = "separator",
    slider = "slider",
    spinButton = "spinbutton",
    switch = "switch",
    tab = "tab",
    tabPanel = "tabpanel",
    textBox = "textbox",
    treeItem = "treeitem",
    comboBox = "combobox",
    grid = "grid",
    listBox = "listbox",
    menu = "menu",
    menuBar = "menubar",
    radioGroup = "radiogroup",
    tabList = "tablist",
    tree = "tree",
    treeGrid = "treegrid",
    application = "application",
    article = "article",
    cell = "cell",
    columnHeader = "columnheader",
    definition = "definition",
    directory = "directory",
    document = "document",
    feed = "feed",
    figure = "figure",
    group = "group",
    heading = "heading",
    img = "img",
    list = "list",
    listItem = "listitem",
    math = "math",
    none = "none",
    note = "note",
    presentation = "presentation",
    row = "row",
    rowGroup = "rowgroup",
    rowHeader = "rowheader",
    table = "table",
    term = "term",
    toolBar = "toolbar",
    toolTip = "tooltip",
    banner = "banner",
    complementary = "complementary",
    contentInfo = "contentinfo",
    form = "form",
    main = "main",
    navigation = "navigation",
    region = "region",
    search = "search",
    alert = "alert",
    log = "log",
    marquee = "marquee",
    status = "status",
    timer = "timer",
    alertDialog = "alertdialog",
    dialog = "dialog",
}
